module.exports = __webpack_public_path__ + "static/media/nomaan.9e742023.jpeg";